class VanillaDropDown {
  constructor(selector = ".js-drop-down", options = {}) {
    this.selector = selector;
    this.triggerSelector = options.triggerSelector || ".js-drop-down-trigger";
    this.contentSelector = options.contentSelector || ".js-drop-down-cnt";
    this.activeClass = options.activeClass || "--drop-down-active";
    this.breakpoint = options.breakpoint || 768;
    this.mediaQuery = window.matchMedia(`(max-width: ${this.breakpoint}px)`);
    this.items = [];

    this.handleMediaChange = this.handleMediaChange.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  init() {
    const elements = document.querySelectorAll(this.selector);

    elements.forEach((element) => {
      const trigger = element.querySelector(this.triggerSelector);
      const content = element.querySelector(this.contentSelector);

      if (!trigger || !content) return;

      const item = {
        element,
        trigger,
        content,
      };

      item.handleClick = (event) => {
        this.handleClick(event, item);
      };

      trigger.addEventListener("click", item.handleClick);

      this.items.push(item);
    });

    if (!this.items.length) return;

    this.mediaQuery.addEventListener("change", this.handleMediaChange);
    window.addEventListener("resize", this.handleResize);

    this.updateState();
  }

  handleClick(event, item) {
    if (!this.mediaQuery.matches) return;

    event.preventDefault();

    this.toggle(item);
  }

  toggle(item) {
    const isActive = item.element.classList.contains(this.activeClass);

    if (isActive) {
      this.close(item);
    } else {
      this.open(item);
    }
  }

  open(item) {
    item.element.classList.add(this.activeClass);
    item.trigger.setAttribute("aria-expanded", "true");
    item.content.setAttribute("aria-hidden", "false");
    item.content.style.height = `${item.content.scrollHeight}px`;
  }

  close(item) {
    item.element.classList.remove(this.activeClass);
    item.trigger.setAttribute("aria-expanded", "false");
    item.content.setAttribute("aria-hidden", "true");
    item.content.style.height = "0px";
  }

  handleMediaChange() {
    this.updateState();
  }

  handleResize() {
    if (!this.mediaQuery.matches) return;

    this.items.forEach((item) => {
      if (!item.element.classList.contains(this.activeClass)) return;

      item.content.style.height = "auto";

      const height = item.content.scrollHeight;

      item.content.style.height = `${height}px`;
    });
  }

  updateState() {
    this.items.forEach((item) => {
      if (this.mediaQuery.matches) {
        const isActive = item.element.classList.contains(this.activeClass);

        item.trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        item.content.setAttribute("aria-hidden", isActive ? "false" : "true");

        if (isActive) {
          item.content.style.height = `${item.content.scrollHeight}px`;
        } else {
          item.content.style.height = "0px";
        }

        return;
      }

      item.element.classList.remove(this.activeClass);
      item.trigger.removeAttribute("aria-expanded");
      item.content.removeAttribute("aria-hidden");
      item.content.style.removeProperty("height");
    });
  }

  destroy() {
    this.items.forEach((item) => {
      item.trigger.removeEventListener("click", item.handleClick);
      item.content.style.removeProperty("height");
    });

    this.mediaQuery.removeEventListener("change", this.handleMediaChange);
    window.removeEventListener("resize", this.handleResize);

    this.items = [];
  }
}

export default VanillaDropDown;
